import React, {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {SectorsNowTable} from "./now/SectorsNowTable";
import SectorsBubbleChart from "./SectorsBubbleChart";
import {useSubscription} from "../../subscription/useSubscription";
import {shadedBackgroundColour, subduedTextColour, tableBorderColour} from "../../../style/styleConsts";
import {SectorsChangeTable} from "./change/SectorsChangeTable";
import sectorsActionsFactory from "./sectorsActions";
import Loader from "../../elements/Loader";
import styled from "styled-components";

const ChartBox = styled.div`
    padding: 10px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const CompareControls = styled.div`
    display: flex;
    padding: 10px;
    border-bottom: 1px solid ${tableBorderColour};
    color: ${subduedTextColour}
`;

const initialWaitToAvoidSimultaneousPolling = 5;

const Sectors = ({}) => {
    useSubscription("SECTOR_SUMMARIES", "/ui/api/sector-summary", 60, initialWaitToAvoidSimultaneousPolling);
    const sectors = useSelector(state => state.sectorSummaries);
    const dispatch = useDispatch();

    const sectorsActions = sectorsActionsFactory(dispatch);

    const timePeriodClickListener = useCallback(event => {
        const timePeriod = event.target.value;
        const timePeriodName = event.target.options[event.target.selectedIndex].text;
        sectorsActions.selectTimePeriod(timePeriod, timePeriodName);
    }, []);

    const ideaCounts = sectors.yourContributors;
    if (!ideaCounts) {
        return <Loader/>;
    }
    const ideaHistory = sectors.yourContributorsAverages;

    const selectedTimePeriod = sectors.timePeriod;
    const tableChart = !selectedTimePeriod || selectedTimePeriod === "none"
        ? <SectorsNowTable today={ideaCounts}
                           sectors={sectors}
                           sectorsActions={sectorsActions}/>
        : <SectorsChangeTable today={ideaCounts}
                              previousAverage={ideaHistory[selectedTimePeriod]}
                              sectors={sectors}
                              sectorsActions={sectorsActions}/>;

    return (
        <Container>
            <CompareControls>
                Compare to
                <select className="t-comparison-period-select" value={sectors.timePeriod}
                        onChange={timePeriodClickListener} style={{
                    marginLeft: 5,
                    border: "none",
                    backgroundColor: shadedBackgroundColour,
                    color: subduedTextColour,
                    padding: 3
                }}>
                    <option value="none">None (show absolute)</option>
                    <option value="oneWeek">1 week average</option>
                    <option value="oneMonth">1 month average</option>
                    <option value="oneYear">1 year average</option>
                </select>
            </CompareControls>
            <ChartBox>
                <SectorsBubbleChart sectors={sectors}
                                    previousAverage={ideaHistory[sectors.timePeriod]}/>
            </ChartBox>
            {tableChart}
        </Container>
    );
};

export default Sectors;
